<div *ngIf="username" 
     class="username"
     (touchstart)="onPressStart()"
     (touchend)="onPressEnd()"
     (touchcancel)="onPressEnd()"
     (mousedown)="onPressStart()"
     (mouseup)="onPressEnd()"
     (mouseleave)="onPressEnd()">
  {{inUserLeave ? leaveTitle : welcomeTitle}}, {{username}}!
</div>